import { useState, useEffect, useRef } from "react";

// Custom hook to track active time
export const useActiveTime = (isInactive) => {
    const [activeTime, setActiveTime] = useState(0);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (!isInactive) {
            // Start the timer
            intervalRef.current = setInterval(() => {
                setActiveTime((prevTime) => prevTime + 10);
            }, 10000);
        } else {
            // Clear the timer if inactive
            clearInterval(intervalRef.current);
        }

        // Cleanup
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [isInactive]);

    const resetActiveTime = () => {
        setActiveTime(0);
    };

    return [activeTime, resetActiveTime];
};